
export function getPaginationNumbers(numberOfEntries, entriesPerPage) {
    const numberOfPages = Math.ceil(numberOfEntries/entriesPerPage);

    if (numberOfPages <= 6) {
        return [...Array(numberOfPages).keys()].map(x => ++x);
    }

    const start = [...Array(3).keys()].map(x => ++x);
    const end = [...Array(3).keys()].map(x => numberOfPages-x).reverse();

    if (numberOfPages === 6) {
        return start.concat(end);
    }

    return start.concat([-1]).concat(end);
}

